const sanitizeRegExp = /<script>.*<\/script>/gi;

const sanitizeHTML = (HTML = '') => HTML.replace(sanitizeRegExp, '');

export default sanitizeHTML;
